var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('common-headline',{staticClass:"size-guide__title",attrs:{"type":"2"}},[_vm._v(_vm._s(_vm.data.title))])}
var staticRenderFns = []

export { render, staticRenderFns }